import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_77: FaireProductEntity = {
  token: "catalog_prod_prod-77",
  type: "product",
  name: "Accent Piece",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 71.08,
  msrpDollars: 177.7,
  sku: "AN0077",
  caseSize: 2,
  material: "Linen",
  collectionToken: "col_andean-touch",
  isNew: true,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 418,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
